import gql from "graphql-tag";

export const customersQuery = gql`
  query allCustomer($filters: Filter) {
    allCustomer(filters: $filters) {
      id
      name
    }
  }
`;

export const featureQuery = gql`
  query feature($featureId: ID!) {
    feature(id: $featureId) {
      id
      name
      isActive
      customers {
        id
        name
      }
    }
  }
`;
